import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import * as api from "../2- api/index";
var userSource;

// google auth
export const createXfindGoogleAuth = createAsyncThunk(
  "createXfindGoogleAuth",
  async () => {
    const { data } = await api.googleAuth();

    const user = {
      result: {
        badgeSvg: data.user.badgeSvg,
        badgeName: data.user.badgeName,
        badgeColor: data.user.badgeColor,
        bio: data.user.bio,
        email: data.user.email,
        favoriteNovels: data.user.favoriteNovels,
        firstName: data.user.firstName,
        lastName: data.user.lastName,
        likes: data.user.likes,
        picture: data.user.picture,
        type: data.user.type,
        _id: data.user._id,
      },
      token: data.token,
    };

    console.log("data", data);
    return user;
  }
);
export const logoutUser = createAsyncThunk("logoutUser", async (response) => {
  await api.googleAuthLogout();
  return response;
});

// jwt auth
export const signup = createAsyncThunk(
  "signup/User",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.signUp(formData);
      console.log("dataS", data);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const signin = createAsyncThunk(
  "signin/User",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.signIn(formData);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);

// user details
export const updateUsers = createAsyncThunk(
  "updateUser",
  async (userData, { rejectWithValue }) => {
    try {
      const { data } = await api.updateUser(userData.userId, userData.obj);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const updatelocalUser = createAsyncThunk(
  "updatelocalUser",
  async (userData, { rejectWithValue }) => {
    try {
      const { data } = await api.updateUser(userData.userId, userData.obj);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getLocalUser = createAsyncThunk(
  "getLocalUser",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await api.getLocalUser(id);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getUserComment = createAsyncThunk(
  "getUserComment",
  async (listOfIds, { rejectWithValue }) => {
    try {
      const { data } = await api.fetchuserComments(listOfIds);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
export const getUser = createAsyncThunk(
  "getUser",
  async (id, { rejectWithValue }) => {
    try {
      if (userSource) {
        userSource.cancel();
      }
      const CancelToken = axios.CancelToken;
      userSource = CancelToken.source();

      const { data } = await api.getUser(id, userSource);
      return data;
    } catch (err) {
      // Use `err.response.data` as `action.payload` for a `rejected` action,
      // by explicitly returning it using the `rejectWithValue()` utility
      return rejectWithValue(err.response.data);
    }
  }
);
